import { ModalNavigationEnum } from '../../../shared/constants';

export const AccountSettingsVerticalTabParam: string = `${ModalNavigationEnum.ACCOUNT_SETTINGS}.account-settings.vertical-tab-menu`;
